//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
export default {
  name: "Login",
  data() {
    return {
      ruleForm: {
        loginName: "",
        password: "",
      },
      rules: {
        loginName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      submitFlag: false,
    };
  },
  methods: {
    ...mapActions(["getAccesToken"]),
    /**
     * @descripttion: 提交信息
     * @Author: juanjuanhui
     * @Date: 2021-12-10 14:31:15
     * @param {*} formName
     */
    handleSubmitInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitFlag = true;
          this.$http.login
            .login({ ...this.ruleForm }, "application/x-www-form-urlencoded")
            .then((res) => {
              console.log(res.data);
              localStorage.setItem("user", JSON.stringify(res.data));
              localStorage.setItem("loginTime", new Date().getTime());
              localStorage.setItem("accessToken", res.data.accessToken);
              this.getAccesToken(res.data.accessToken);
              this.$message.success("登录成功");
              this.$router.push({ path: "/" });
            })
            .catch((err) => {
              console.log(err);
              this.submitFlag = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
